<script>
  import { onMount, onDestroy } from 'svelte';
  export let exam
  export let participant
  import { tweened } from 'svelte/motion';
  export let original = 120 * 60;
  export let timer = tweened(original)
  export let finish_link
  export let duration = duration
  export let online
  export let exam_session_id

  let countdownInterval
  let syncInterval

  onMount(() => {
    countdownInterval = setInterval(() => {
      if ($timer > 0) $timer--;
      if ($timer <= 0) post(finish_link);
    }, 1000);

    syncInterval = setInterval(syncTimer, 5000);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    syncTimer();
  });

  onDestroy(() => {
    clearInterval(countdownInterval);
    clearInterval(syncInterval);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  });

  function handleVisibilityChange() {
    if (!document.hidden) syncTimer();
  }

  async function syncTimer() {
    if (document.hidden || !exam_session_id) return;

    try {
      const response = await fetch('/quiz/' + exam_session_id + '/timer', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
      if (response.status === 401) {
        window.location.href = '/login';
        return;
      }
      if (!response.ok) return;

      const data = await response.json();
      if (data.finished || data.expired) {
        timer.set(0, { duration: 0 });
        post(finish_link);
        return;
      }

      timer.set(data.remaining_seconds, { duration: 0 });
      if (data.total_seconds > 0) duration = data.total_seconds;
    } catch (error) {}
  }

  $: hours = twoDigits(Math.floor($timer / 3600))
  $: minutes = twoDigits(Math.floor($timer / 60) % 60)
  $: seconds = twoDigits(Math.floor($timer % 60))
  $: progressValue = duration > 0 ? $timer / duration : 0
  $: timerLow = $timer > 0 && $timer <= 300

  function twoDigits(value) {
    if (value.toString().length <= 1) {
      return '0' + value.toString();
    }
    return value.toString();
  }

  function post(path, method='post') {
    const form = document.createElement('form');
    form.method = method;
    form.action = path;
    document.body.appendChild(form);
    form.submit();
  }
</script>

<header class="cbt-quiz-header">
  <div class="cbt-quiz-header__main">
    <div class="cbt-quiz-header__exam">
      <p class="cbt-quiz-header__label">Sedang mengerjakan</p>
      <h1 class="cbt-quiz-header__title">{ exam.name }</h1>
    </div>

    <div class="cbt-quiz-header__participant">
      <p class="cbt-quiz-header__name">{ participant.name }</p>
      <p class="cbt-quiz-header__uic">{ participant.uic }</p>
    </div>
  </div>

  <div class="cbt-quiz-header__status">
    <div class="cbt-quiz-timer {timerLow ? 'cbt-quiz-timer--low' : ''}">
      {#if $timer < 1}
        <span class="cbt-quiz-timer__expired">Waktu habis</span>
      {:else}
        <span class="cbt-quiz-timer__value">{hours}:{minutes}:{seconds}</span>
        <span class="cbt-quiz-timer__label">Sisa waktu</span>
      {/if}
    </div>

    <span class="cbt-quiz-connection {online ? 'cbt-quiz-connection--online' : 'cbt-quiz-connection--offline'}">
      {online ? 'Online' : 'Offline'}
    </span>
  </div>

  <div class="cbt-quiz-progress">
    <div class="cbt-quiz-progress__bar" style="width: {Math.max(progressValue * 100, 0)}%"></div>
  </div>
</header>
